/* product-comparison-slider.js
 * <comparison-slider> — a draggable before/after image slider used at the
 * top of the Product comparison section, for comparing two product
 * variants (e.g. Standard vs Pro) side by side. A native range input is
 * the source of truth (keyboard + screen reader accessible); dragging the
 * divider handle or the frame itself just moves that same range value.
 */
class ComparisonSlider extends HTMLElement {
  connectedCallback() {
    this.range = this.querySelector('.product-compare__slider-range');
    this.frame = this.querySelector('.product-compare__slider-frame');
    this.beforeMedia = this.querySelector('.product-compare__slider-media--before');
    this.divider = this.querySelector('.product-compare__slider-divider');

    if (!this.range || !this.frame || !this.beforeMedia || !this.divider) return;

    this.range.addEventListener('input', () => this.setPosition(this.range.value));

    this.dragging = false;
    this.divider.addEventListener('pointerdown', (event) => this.startDrag(event));
    this.frame.addEventListener('pointerdown', (event) => this.startDrag(event));
    window.addEventListener('pointermove', (event) => this.onDrag(event));
    window.addEventListener('pointerup', () => {
      this.dragging = false;
    });

    this.setPosition(this.range.value);
  }

  startDrag(event) {
    this.dragging = true;
    this.updateFromClientX(event.clientX);
  }

  onDrag(event) {
    if (!this.dragging) return;
    this.updateFromClientX(event.clientX);
  }

  updateFromClientX(clientX) {
    const rect = this.frame.getBoundingClientRect();
    const ratio = (clientX - rect.left) / rect.width;
    const value = Math.min(100, Math.max(0, Math.round(ratio * 100)));
    this.range.value = value;
    this.setPosition(value);
  }

  setPosition(value) {
    this.beforeMedia.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
    this.divider.style.left = `${value}%`;
  }
}

customElements.define('comparison-slider', ComparisonSlider);
